/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { fetchUsers } from './users.thunk';

/* Initial state */
const initialState = {
  usersData: {
    status: ThunkStatus.IDLE,
    page: {},
    rowItems: [],
  },
};

/* Slice */
export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    userUpdated(state, action) {
      const updatedUser = action.payload;

      state.usersData.rowItems = state.usersData.rowItems.map(userRow =>
        userRow.id === updatedUser.id ? updatedUser : userRow,
      );
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.usersData.status = ThunkStatus.LOADING;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.usersData.status = ThunkStatus.SUCCEEDED;
        state.usersData.rowItems = action.payload.usersPage.content;
        state.usersData.page.totalElements = action.payload.usersPage.totalElements;
        state.usersData.page.totalPages = action.payload.usersPage.totalPages;
      })
      .addCase(fetchUsers.rejected, (state) => {
        state.usersData.status = ThunkStatus.FAILED;
        state.usersData.rowItems = [];
      });
  },
});

/* Selectors */
const selectUsers = state => state[usersSlice.name];
export const selectStatus = createSelector(selectUsers, ({ userData }) => userData.status);
export const selectUsersData = createSelector(selectUsers, ({ usersData }) => usersData);
export const selectUsersRows = createSelector(selectUsersData, ({ rowItems }) => rowItems);

/* Actions */
export const { userUpdated } = usersSlice.actions;
